import { ConfigItemAtList, ConfigItemType } from "domains/managingJson/store/types"

const CONFIG_ITEM_ROUTE_PREFIXES: [ConfigItemType, string][] = [
  ["contests", "contest"],
  ["communityEvents", "community-event"],
]

export const configItemRoutes = (itemTypes: ConfigItemAtList[] = []) => (
  CONFIG_ITEM_ROUTE_PREFIXES.flatMap(([type, prefix]) => (
    itemTypes
      .filter(item => item.type === type)
      .map(({ name }) => ({ value: `internal?id=${prefix}/${name}`, title: `${prefix}/${name}` }))
  ))
)
